import { OrdemDeServicoFormData } from '../../types/ordemServico';

export function calculateHoraTotal(horarioInicio: string, horarioFinal: string): string {
  if (!horarioInicio || !horarioFinal) return '';
  try {
    const [h1, m1] = horarioInicio.split(':').map(Number);
    const [h2, m2] = horarioFinal.split(':').map(Number);

    if (isNaN(h1) || isNaN(m1) || isNaN(h2) || isNaN(m2)) return '';

    let totalMin1 = h1 * 60 + m1;
    let totalMin2 = h2 * 60 + m2;

    if (totalMin2 < totalMin1) {
      // Passou da meia noite
      totalMin2 += 24 * 60;
    }

    const diff = totalMin2 - totalMin1;
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;

    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');

    return `${hh}:${mm}`;
  } catch {
    return '';
  }
}

export function recalculateOS(prev: OrdemDeServicoFormData): OrdemDeServicoFormData {
  // 1. Subtotal Ajudante / Viagem = valor_unit_ajud * quantidade_ajudante
  const subtotal_viagem = Number((prev.valor_unit_ajud * prev.quantidade_ajudante).toFixed(2));

  // 2. Total O.S = valor_unit_servi + subtotal_viagem + adicional
  const total_os = Number((prev.valor_unit_servi + subtotal_viagem + prev.adicional).toFixed(2));

  // 3. Repasse Ajudantes (soma da lista de ajudantes)
  const ajudante_repasse = prev.ajudantes_list.reduce((acc, row) => {
    const val = typeof row.repasse_ajudante === 'number' ? row.repasse_ajudante : parseFloat(row.repasse_ajudante) || 0;
    return acc + val;
  }, 0);

  // 4. Valor Total Repasses = repasse + valor_despesa + ajudante_repasse
  const repasseNum = typeof prev.repasse === 'number' ? prev.repasse : parseFloat(prev.repasse as any) || 0;
  const valorDespesaNum = typeof prev.valor_despesa === 'number' ? prev.valor_despesa : parseFloat(prev.valor_despesa as any) || 0;
  
  const valor_total_repasses = Number((repasseNum + valorDespesaNum + ajudante_repasse).toFixed(2));

  // 5. Valor Liquido = total_os - valor_total_repasses
  const valor_liquido = Number((total_os - valor_total_repasses).toFixed(2));

  return {
    ...prev,
    subtotal_viagem,
    total_os,
    ajudante_repasse,
    valor_total_repasses,
    valor_liquido,
  };
}
